import React, { createContext, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../i18n'; // Initialize i18next

const LanguageContext = createContext();

// Available languages configuration
const availableLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
];

export const LanguageProvider = ({ children }) => {
  const { t, i18n } = useTranslation();
  
  // Current language
  const language = i18n.language || 'en';
  
  // Change language function
  const setLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('preferredLanguage', langCode);
    // Update HTML lang attribute for accessibility
    document.documentElement.lang = langCode;
  };
  
  // Set initial HTML lang attribute
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);
  
  const value = {
    language,
    setLanguage,
    t, // Translation function from i18next
    availableLanguages,
    i18n, // Expose i18n instance for advanced usage
  };
  
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
